<template>
	<div>
		<div class="form-group">
			<label
				v-if="showLabel && label"
				:for="'form-radiogroup-' + field.adPropertyKey"
				class="d-block form-label"
				>{{ label }}</label
			>
			<div
				class="radio-group cm-radio-group-color row row-cols-5 g-2"
				:id="'form-radiogroup-' + field.adPropertyKey"
			>
				<template v-for="option in options" :key="option">
					<div
						class="color col"
						:class="option.adPropertyValue.toLowerCase()"
						v-if="option.adPropertyValue !== ''"
					>
						<input
							v-if="option.adPropertyValue === model"
							v-model="model"
							class="form-check-input"
							type="radio"
							@change="uncheckRadio()"
							:name="'form-radio-' + field.adPropertyKey"
							:id="
								'form-radio-' +
								field.adPropertyKey +
								'-' +
								option.adPropertyValue.toLowerCase()
							"
							:value="option.adPropertyValue"
						/>
						<input
							v-model="model"
							class="form-check-input"
							type="radio"
							@change="updateFilter()"
							:name="'form-radio-' + field.adPropertyKey"
							:id="
								'form-radio-' +
								field.adPropertyKey +
								'-' +
								option.adPropertyValue.toLowerCase()
							"
							:value="option.adPropertyValue"
						/>
						<label
							:title="option.name"
							class="form-check-label"
							:class="[
								'label-' + option.adPropertyValue.toLowerCase(),
								{ active: model === option.adPropertyValue },
							]"
							:for="
								'form-radio-' +
								field.adPropertyKey +
								'-' +
								option.adPropertyValue.toLowerCase()
							"
						>
						</label>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'FormRadioColor',
	data() {
		return {
			selected: '',
			isChecked: true,
			model: '',
		}
	},
	props: {
		label: {
			type: String,
			default: '',
		},
		showLabel: {
			type: Boolean,
			required: false,
			default: true,
		},
		field: {
			type: Object,
			required: true,
		},
		showAll: {
			type: Boolean,
			required: false,
			default: true,
		},
	},
	computed: {
		options() {
			let hits = this.field.hits
			return hits.sort((a, b) =>
				a.adPropertyValue.toLowerCase() > b.adPropertyValue.toLowerCase()
					? 1
					: -1
			)
		},
	},
	methods: {
		uncheckRadio() {
			this.model = ''
			store.commit('deleteFilter', this.field.adPropertyKey)
			this.$emit('updateFilter', this.model)
		},
		updateFilter() {
			if (this.model !== '') {
				const filterItem = {
					adPropertyKey: this.field.adPropertyKey,
					adPropertyType: this.field.adPropertyType,
					adPropertyValue: this.model,
				}
				store.commit('updateFilter', filterItem)
			} else {
				store.commit('deleteFilter', this.field.adPropertyKey)
			}
			this.$emit('updateFilter')
		},
	},
	created() {
		this.unsubscribe = store.subscribe((mutation, state) => {
			if (
				mutation.type === 'deleteFilter' ||
				mutation.type === 'deleteAllFilter'
			) {
				if (
					state.filterItems[this.field.adPropertyKey] === undefined &&
					this.model !== ''
				) {
					this.model = ''
				}
			}
		})
	},
	beforeUnmount() {
		this.unsubscribe()
	},
}
</script>

<style lang="scss" scoped>
input {
	position: absolute;
	opacity: 0;
}

.cm-radio-group-color {
	.color {
		//margin-bottom: 8px;
		overflow: hidden;
		padding: 4px;

		> label {
			border-radius: $border-radius;
			border: $border;
			display: block;
			position: relative;
			height: 36px;

			&.label-black {
				color: #fff;
				background: #474747;
				background: -moz-linear-gradient(-45deg, #474747 0%, #191919 100%);
				background: -webkit-linear-gradient(-45deg, #474747 0%, #191919 100%);
				background: -webkit-linear-gradient(315deg, #474747 0%, #191919 100%);
				background: -o-linear-gradient(315deg, #474747 0%, #191919 100%);
				background: linear-gradient(135deg, #474747 0%, #191919 100%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#474747', endColorstr='#191919', GradientType=1);
				border: 1px solid #000;
			}

			&.label-white {
				color: #000;
				background: white;
				background: -moz-linear-gradient(-45deg, white 0%, #dddddd 100%);
				background: -webkit-linear-gradient(-45deg, white 0%, #dddddd 100%);
				background: -o-linear-gradient(315deg, white 0%, #dddddd 100%);
				background: linear-gradient(135deg, white 0%, #dddddd 100%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#dddddd', GradientType=1);
				border: 1px solid #bbbbbb;
			}

			&.label-grey {
				color: #fff;
				background: #aaaaaa;
				background: -moz-linear-gradient(-45deg, #aaaaaa 0%, #555555 100%);
				background: -webkit-linear-gradient(-45deg, #aaaaaa 0%, #555555 100%);
				background: -o-linear-gradient(315deg, #aaaaaa 0%, #555555 100%);
				background: linear-gradient(135deg, #aaaaaa 0%, #555555 100%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#aaaaaa', endColorstr='#555555', GradientType=1);
				border: 1px solid #444;
			}

			&.label-blue {
				color: #fff;
				background: #4492d0;
				background: -moz-linear-gradient(-45deg, #4492d0 0%, #204a86 100%);
				background: -webkit-linear-gradient(-45deg, #4492d0 0%, #204a86 100%);
				background: -o-linear-gradient(315deg, #4492d0 0%, #204a86 100%);
				background: linear-gradient(135deg, #4492d0 0%, #204a86 100%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#4492d0', endColorstr='#204a86', GradientType=1);
				border: 1px solid #002a66;
			}

			&.label-green {
				color: #fff;
				background: #c4e890;
				background: -moz-linear-gradient(-45deg, #c4e890 0%, #679e1e 100%);
				background: -webkit-linear-gradient(-45deg, #c4e890 0%, #679e1e 100%);
				background: -o-linear-gradient(315deg, #c4e890 0%, #679e1e 100%);
				background: linear-gradient(135deg, #c4e890 0%, #679e1e 100%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#c4e890', endColorstr='#679e1e', GradientType=1);
				border: 1px solid #009900;
			}

			&.label-red {
				color: #fff;
				background: #fc4643;
				background: -moz-linear-gradient(-45deg, #fc4643 0%, #9f1429 100%);
				background: -webkit-linear-gradient(-45deg, #fc4643 0%, #9f1429 100%);
				background: -o-linear-gradient(315deg, #fc4643 0%, #9f1429 100%);
				background: linear-gradient(135deg, #fc4643 0%, #9f1429 100%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fc4643', endColorstr='#9f1429', GradientType=1);
				border: 1px solid #990000;
			}

			&.label-orange {
				color: #fff;
				background: #fab421;
				background: -moz-linear-gradient(-45deg, #fab421 0%, #e3902a 100%);
				background: -webkit-linear-gradient(-45deg, #fab421 0%, #e3902a 100%);
				background: -webkit-linear-gradient(315deg, #fab421 0%, #e3902a 100%);
				background: -o-linear-gradient(315deg, #fab421 0%, #e3902a 100%);
				background: linear-gradient(135deg, #fab421 0%, #e3902a 100%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fab421', endColorstr='#e3902a', GradientType=1);
				border: 1px solid #bb7700;
			}

			&.label-yellow {
				color: #000;
				background: #ffff88;
				background: -moz-linear-gradient(-45deg, #ffff88 0%, #ffdd00 100%);
				background: -webkit-linear-gradient(-45deg, #ffff88 0%, #ffdd00 100%);
				background: -webkit-linear-gradient(315deg, #ffff88 0%, #ffdd00 100%);
				background: -o-linear-gradient(315deg, #ffff88 0%, #ffdd00 100%);
				background: linear-gradient(135deg, #ffff88 0%, #ffdd00 100%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffff88', endColorstr='#ffdd00', GradientType=1);
				border: 1px solid #cccc00;
			}

			&.label-violet {
				color: #fff;
				background: #935d93;
				background: -moz-linear-gradient(-45deg, #935d93 0%, #592472 100%);
				background: -webkit-linear-gradient(-45deg, #935d93 0%, #592472 100%);
				background: -webkit-linear-gradient(315deg, #935d93 0%, #592472 100%);
				background: -o-linear-gradient(315deg, #935d93 0%, #592472 100%);
				background: linear-gradient(135deg, #935d93 0%, #592472 100%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#935d93', endColorstr='#592472', GradientType=1);
				border: 1px solid #550055;
			}

			&.label-brown {
				color: #fff;
				background: #b97a57;
				background: -moz-linear-gradient(-45deg, #b97a57 0%, #793a27 100%);
				background: -webkit-linear-gradient(-45deg, #b97a57 0%, #793a27 100%);
				background: -webkit-linear-gradient(315deg, #b97a57 0%, #793a27 100%);
				background: -o-linear-gradient(315deg, #b97a57 0%, #793a27 100%);
				background: linear-gradient(135deg, #b97a57 0%, #793a27 100%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#b97a57', endColorstr='#793a27', GradientType=1);
				border: 1px solid #692a17;
			}

			&.label-beige {
				color: #000;
				background: #fceccc;
				background: -moz-linear-gradient(-45deg, #fceccc 0%, #ccbb99 100%);
				background: -webkit-linear-gradient(-45deg, #fceccc 0%, #ccbb99 100%);
				background: -webkit-linear-gradient(315deg, #fceccc 0%, #ccbb99 100%);
				background: -o-linear-gradient(315deg, #fceccc 0%, #ccbb99 100%);
				background: linear-gradient(135deg, #fceccc 0%, #ccbb99 100%);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fceccc', endColorstr='#ccbb99', GradientType=1);
				border: 1px solid #cebea4;
			}

			&.label-silver {
				color: #000;
				background: #c1c1c1;
				background: -moz-linear-gradient(
					-45deg,
					#c1c1c1 0%,
					white 50%,
					#b2b2b2 100%
				);
				background: -webkit-linear-gradient(
					-45deg,
					#c1c1c1 0%,
					white 50%,
					#b2b2b2 100%
				);
				background: -webkit-linear-gradient(
					315deg,
					#c1c1c1 0%,
					white 50%,
					#b2b2b2 100%
				);
				background: -o-linear-gradient(
					315deg,
					#c1c1c1 0%,
					white 50%,
					#b2b2b2 100%
				);
				background: linear-gradient(
					135deg,
					#c1c1c1 0%,
					white 50%,
					#b2b2b2 100%
				);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#c1c1c1', endColorstr='#b2b2b2', GradientType=1);
				border: 1px solid #9c9c9c;
			}

			&.label-gold {
				color: #000;
				background: #ffd905;
				background: -moz-linear-gradient(
					-45deg,
					#ffd905 0%,
					#fff291 50%,
					#ffd905 100%
				);
				background: -webkit-linear-gradient(
					-45deg,
					#ffd905 0%,
					#fff291 50%,
					#ffd905 100%
				);
				background: -webkit-linear-gradient(
					315deg,
					#ffd905 0%,
					#fff291 50%,
					#ffd905 100%
				);
				background: -o-linear-gradient(
					315deg,
					#ffd905 0%,
					#fff291 50%,
					#ffd905 100%
				);
				background: linear-gradient(
					135deg,
					#ffd905 0%,
					#fff291 50%,
					#ffd905 100%
				);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffd905', endColorstr='#ffd905', GradientType=1);
				border: 1px solid #e5c004;
			}

			&.label-bronze {
				color: #fff;
				background: #c17228;
				background: -moz-linear-gradient(
					-45deg,
					#c17228 0%,
					#efd3b8 50%,
					#c17228 100%
				);
				background: -webkit-linear-gradient(
					-45deg,
					#c17228 0%,
					#efd3b8 50%,
					#c17228 100%
				);
				background: -webkit-linear-gradient(
					315deg,
					#c17228 0%,
					#efd3b8 50%,
					#c17228 100%
				);
				background: -o-linear-gradient(
					315deg,
					#c17228 0%,
					#efd3b8 50%,
					#c17228 100%
				);
				background: linear-gradient(
					135deg,
					#c17228 0%,
					#efd3b8 50%,
					#c17228 100%
				);
				filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#c17228', endColorstr='#c17228', GradientType=1);
				border: 1px solid #995a20;
			}

			&:hover {
				cursor: pointer;
				-webkit-box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.8);
				box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.8);

				&:after {
					font-size: $px20;
					position: absolute;
					top: 2px;
					left: 8px;
					font-family: 'Material Design Icons';
					opacity: 0.6;
					content: '\F0E1E';
				}
			}

			&.active {
				cursor: pointer;
				-webkit-box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.3);
				box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.3);

				&:after {
					font-size: $px20;
					position: absolute;
					top: 2px;
					left: 8px;
					font-family: 'Material Design Icons';
					content: '\F0E1E';
				}

				&:hover {
					-webkit-box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.8);
					box-shadow: inset 0px 0px 0px 1px rgba(255, 255, 255, 0.8);
					&:after {
						opacity: 1;
						content: '\F1398';
					}
				}
			}
		}
	}
}
</style>
